module.exports = "/_next/static/images/introSectionCard5-bfceb716c8c3b098c82920453edd6d27.svg";